/* global Blockly */
import React from 'react';
import { getPagesFromContext } from "../../../v1/helpers";

function defineBlock(formPages) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("navigate to ")
                .appendField(new Blockly.FieldDropdown(formPages), "TOPAGE");
            this.appendStatementInput('THEN').appendField('then');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Navigate to a new page in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let toPage = block.getFieldValue('TOPAGE').split('<<<>>>').slice(-1);
            let innerBlockCode = Blockly.JavaScript.statementToCode(block, 'THEN');

            let code = `
            actionsModule.executeActionWithCallback({
                action: {
                    actionType: "navigate",
                    parameters: {
                        navigateTo: "${toPage}"
                    }
                }
            }, function() {
                ${innerBlockCode}
            });\n`;

            return code;
        }
    }
}

const SnapActionNavigate = function (props) {
    let name = "snap_action_navigate_V3";
    SnapActionNavigate.blockName = name;

    const formPages = getPagesFromContext(props.context);
    if (formPages.length === 0) {
        return null;
    }

    Blockly.Blocks[name] = defineBlock(formPages);

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return (
        <block type={name}></block>
    );
};

export default SnapActionNavigate;
